<!-- Sidebar -->
<div class="sidebar">
  <div class="sidebar-inner-wrapper">
    <div class="top-option logo">
      <a routerLink="/dashboard" class="sidebar-option logo">
        <span class="left-part logo">
          <span class="img-wrap logo">
            <img class="logo" src="assets/img/mi-logo.png" alt="Mail Innovation Logo">
          </span>
        </span>
      </a>
    </div>
    <nav class="navigation">
      <ul class="navigation-list">
        <!-- <li *ngFor="let sideItem of sideNavItems" routerLinkActive="active">
        <span class="sidebar-option-wrap">
          <a [routerLink]="sideItem.routerLink" class="sidebar-option">
            <span class="left-part">
              <span [class]="sideItem.iconClass"></span>
              <span class="txt-small">{{sideItem.menuName}}</span>
            </span>
          </a>
        </span>
      </li> -->

      @if (isRequestPage) {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/home" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-home"></span>
                <span class="txt-small sidenav">Home Page</span>
              </span>
            </a>
          </span>
        </li>
      }
      @if (!isRequestPage && permissions.RaiseRequestPermissions) {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/requests/new" class="sidebar-option sidenav" (click)="onGoToReports()">
              <span class="left-part">
                <span class="icon icon-module-reports sidenav"></span>
                <span class="txt-small sidenav">New/View Requests</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (!isRequestPage && permissions.ApprovalDashboardPermissions) {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/approval/approval-dashboard" class="sidebar-option sidenav" (click)="onGoToApps()">
              <span class="left-part sidenav">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Approval Dashboard</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (!isRequestPage && permissions.ViewReportsPermissions) {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/request-status-reports" class="sidebar-option sidenav">
              <span class="left-part sidenav">
                <span class="icon icon-icon-excel sidenav"></span>
                <span class="txt-small sidenav">Request Status & Report</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location =='/requests/new' || location =='/requests/history'  || location =='/requests/prs-request') {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/requests/new" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-reports sidenav"></span>
                <span class="txt-small sidenav">New/Edit Request</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location =='/requests/new' || location =='/requests/history' || location =='/requests/prs-request') {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/requests/history" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">View History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location =='/requests/new' || location =='/requests/history' || location =='/requests/prs-request') {
        <li routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/requests/prs-request" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">PRS</span>
                <span class="txt-small sidenav font-small-99">Consolidated</span>
                <span class="txt-small sidenav">Requests</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location == '/approval/approval-dashboard' || location == '/approval/approval-history') {
        <li [ngClass]="{'active': location == '/approval/approval-dashboard'}">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/approval/approval-dashboard" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Pending</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location == '/approval/approval-dashboard' || location == '/approval/approval-history') {
        <li  routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/approval/approval-history" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Approval History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location == '/gbs/gbs-dashboard' || location == '/gbs/gbs-history' || location == '/gbs/gbs-process-request') {
        <li  routerLinkActive="active" [ngClass]="{'active': location == '/approval/approval-dashboard'}">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/gbs/gbs-dashboard" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">GBS Pending</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (location == '/gbs/gbs-dashboard' || location == '/gbs/gbs-history' || location == '/gbs/gbs-process-request') {
        <li  routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/gbs/gbs-history" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">GBS History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkUploader && (location == '/bulk-request' || location=='/bulk-request-history' ||location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory'|| location=='/bulk-request-gbshistory'|| location=='/bulk-request-gbspending')) {
        <li  routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">  Upload</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkUploader && (location == '/bulk-request' || location == '/bulk-request-history' ||location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory'|| location=='/bulk-request-gbshistory'|| location=='/bulk-request-gbspending')) {
        <li  routerLinkActive="active">
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-history" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Upload History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkApprover && (location == '/bulk-request' || location == '/bulk-request-history' || location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-approvaldashboard" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Pending Approvals</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkApprover && (location == '/bulk-request' || location == '/bulk-request-history' || location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-approvalhistory" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Approval History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkGbser && (location == '/bulk-request' || location == '/bulk-request-history' || location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory'|| location=='/bulk-request-gbshistory'|| location=='/bulk-request-gbspending')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-gbspending" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">GBS Pending</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if (isBulkGbser && (location == '/bulk-request' || location == '/bulk-request-history' || location == '/bulk-request-approvaldashboard'|| location=='/bulk-request-approvalhistory'|| location=='/bulk-request-gbshistory'|| location=='/bulk-request-gbspending')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-gbshistory" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">GBS History</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if ((location == '/bulk-request-reports' || location=='/request-status-reports' || location=='/detailed-reports')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/request-status-reports" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Report</span>
              </span>
            </a>
          </span>
        </li>
      }
      &nbsp;
      @if ((location == '/bulk-request-reports' || location=='/request-status-reports' || location=='/detailed-reports')) {
        <li  routerLinkActive="active" >
          <span class="sidebar-option-wrap sidenav">
            <a routerLink="/bulk-request-reports" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
              <span class="left-part">
                <span class="icon icon-module-assets sidenav"></span>
                <span class="txt-small sidenav">Bulk Requests Report</span>
              </span>
            </a>
          </span>
        </li>
      }




      <!-- <li routerLinkActive="active"  *ngIf="location == '/approval-dashboard'">
      <span class="sidebar-option-wrap sidenav">
        <a class="sidebar-option sidenav" >
          <span class="left-part">
            <span class="icon icon-module-reports sidenav"></span>
            <span class="txt-small sidenav">History</span>
          </span>
        </a>
      </span>
    </li> -->


    <!-- <li routerLinkActive="active">
    <span class="sidebar-option-wrap sidenav">
      <a routerLink="/contact" class="sidebar-option sidenav" (click)="onGoToOtherMenu()">
        <span class="left-part sidenav">
          <span class="icon icon-module-fsl sidenav"></span>
          <span class="txt-small sidenav">Contact</span>
        </span>
      </a>
    </span>
  </li>         -->
</ul>
</nav>
</div>
</div>